// eslint-disable-next-line
export function random(array: any[]) {
  return array[Math.floor(Math.random() * array.length)];
}

export function uniqueNumbers(
  count: number,
  min: number,
  max: number,
  list: number[] = []
): number[] {
  const num = Math.floor(Math.random() * (max - min)) + min;
  if (list.includes(num)) return uniqueNumbers(count, min, max, list);
  list.push(num);
  return list.length === count ? list : uniqueNumbers(count, min, max, list);
}

// eslint-disable-next-line
export function shuffle(array: any[]) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

export function pluralize(string: string, number: number) {
  if (number === 1) return string;
  return `${string}s`;
}

export function capitalize(string: string) {
  return `${string.charAt(0).toUpperCase()}${string.substring(1)}`;
}
